<template>
    <b-modal :active.sync="isComponentModalActive"
             has-modal-card full-screen >

        <div class="modal-card ">
            <section class="modal-card-body"  >
                <b-loading  :active.sync="isFullScreenLoading" />

                <p class="is-size-3">  Disable LAB Reason Management</p>
                <hr>
                <b-button type="is-success" outlined  @click="loadData"  >Refresh or Reload </b-button>

                &nbsp; <b-button type="is-info"   icon-left="plus" @click="AddNew"> Add New</b-button>

                <b-table
                        :data="dataDisables"
                        >

                    <b-table-column label="ID"  v-slot="props">
                        {{ props.row.id }}
                    </b-table-column>

                    <b-table-column label="DESCP."  v-slot="props">
                        {{ props.row.name }}
                    </b-table-column>


                    <b-table-column label="User Rec."  v-slot="props">
                        {{ props.row.user_rec }}
                    </b-table-column>


                    <b-table-column label="DateTime Rec."  v-slot="props">
                        {{ props.row.date_rec }}  ( {{ props.row.time_rec }} )
                    </b-table-column>


                    <b-table-column label="Status"  v-slot="props">
                        <span v-if="props.row.enable"   >
                            Unlock
                        </span>
                        <span v-else >
                            Lock
                        </span>
                        <b-icon pack="fas"
                                :icon="props.row.enable  ?'lock-open' : 'lock'  "
                                :type="props.row.enable  ?'is-success' : 'is-danger' " >

                        </b-icon>
                    </b-table-column>

                    <b-table-column label="Edit"  v-slot="props" >
                        <b-button type="is-danger"   icon-right="pen"  @click="editData( props.row.id,props.row.name, props.row.enable )"/>
                    </b-table-column>

                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>

            </section>
            <footer class="modal-card-foot">
                <b-button size="is-medium" type="is-danger"
                          icon-left="close" @click="closeModal">
                    Close
                </b-button>
            </footer>
        </div>
        <AddNewAndEditDisableReason
                v-if="isAddNewAndEditDisableReason"
                @close="closeAddNewAndEditDisableReason"
                @closeWithChange = "closeAddNewAndEditDisableReasonWithChange"
                :dataToChild="dataToChild"  />
    </b-modal>
</template>

<script>
    import axios from "axios"
    import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
    import AddNewAndEditDisableReason from "./AddNewAndEditDisableReason";
    import { mapState } from "vuex";



    export default {
        name: "DisableReasonManagement",
        components:{
            AddNewAndEditDisableReason
        },
        computed:{
            ...mapState({
               access_token: state => state.master_data.access_token,
            })

        },
        methods:{
            AddNew(){
                // 1 == add , 2 == edit
                this.dataToChild =  {kind : 1 ,dataEdit: {id : "",name : "" , enable : true }}
                this.isAddNewAndEditDisableReason = true
            },
            loadData(){
                const datTo =   {
                                 "admin" : true
                                }

                const vm = this

                this.isFullScreenLoading = true

                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofdisablereason`,datTo,getConfigAxios())
                     .then((res)=>{
                          vm.dataDisables = res.data
                          setTimeout(()=>{
                              vm.isFullScreenLoading = false
                          },500)


                     })
                    .catch(err=>{
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.alert({
                            title: 'Error',
                            message: `Error  from ${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })




            },

            editData(_id,_name,_enable){
                this.dataToChild =  {kind : 2 ,dataEdit: {id : _id,name : _name , enable : _enable }}
                this.isAddNewAndEditDisableReason = true
            },
            closeModal(){
                this.isComponentModalActive = false
            },
            closeAddNewAndEditDisableReason(){
                this.isAddNewAndEditDisableReason = false
            },
            closeAddNewAndEditDisableReasonWithChange(){
                this.isAddNewAndEditDisableReason = false
                this.loadData()
            }
        },
        data(){
            return{
                isComponentModalActive : false,
                isFullScreenLoading : false,

                dataDisables :[],
                isEmpty : false,
                isAddNewAndEditDisableReason : false,
                dataToChild :  {kind : null ,dataEdit: null}  // kind 1 addNew , 2 edit
            }
        }
    }
</script>

<style scoped>

</style>